import { useParams, Navigate } from 'react-router-dom';
import DefaultReceptionPage from '../reception/DefaultReceptionPage';

const REDIRECT_TO_INFO_DESK = new Set(['bayviewyards', 'areaxo']);

export default function OrgDashboardPage() {
  const { slug } = useParams<{ slug: string }>();
  if (slug && REDIRECT_TO_INFO_DESK.has(slug)) {
    return <Navigate to={`/${slug}/information-desk`} replace />;
  }
  return <DefaultReceptionPage />;
}
